import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput
} from 'react-admin';

export default function ProcedureCreate(props) {
  return (
      <Create {...props}>
      <SimpleForm>
        <TextInput source="name" />
        <TextInput source="tuss" />
      </SimpleForm>
    </Create>
  );
}